<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .conference-call {
    width: utils.in_rem(244px);

    .top-row {
      position: relative;

      &.expanded::after {
        border-bottom: utils.in_rem(1px) solid
          colors.get(interfaceTransparentWhite_15);
        bottom: 0;
        content: "";
        left: 0;
        position: absolute;
        right: 0;
      }
    }

    .conference-header {
      background-color: colors.get(interfaceTransparentBlack_30);
      border-radius: utils.in_rem(8px);
      padding: utils.in_rem(8px);

      &.expanded {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      .profile-container {
        align-items: center;
        display: flex;
        justify-content: space-between;

        .contact {
          align-items: center;
          display: flex;
          gap: utils.in_rem(8px);

          .conference-avatar {
            align-items: center;
            background-color: colors.get(interfaceTransparentWhite_15);
            border-radius: utils.in_rem(8px);
            display: flex;
            height: utils.in_rem(28px);
            justify-content: center;
            width: utils.in_rem(28px);

            i {
              color: colors.get(textWhite);
              font-family: "Font Awesome 6 Pro";
              font-size: utils.in_rem(14px);
              font-weight: 900;
            }
          }

          .profile-info {
            display: flex;
            flex-direction: column;
            line-height: 1.2;

            .title {
              @include mixins.h4;
              color: colors.get(textWhite);
              white-space: nowrap;
            }

            .subtitle {
              @include mixins.body4;
              color: colors.get(interfaceTransparentWhite_70);
              white-space: nowrap;
            }
          }
        }

        .chevron {
          background: none;
          border: none;
          color: colors.get(textWhite);
          cursor: pointer;
          font-family: "Font Awesome 6 Pro";
          font-size: utils.in_rem(10px);
          font-weight: 400;
          padding: 0;
          width: utils.in_rem(26px);
        }
      }
    }

    .contacts-panel {
      background-color: colors.get(interfaceTransparentBlack_30);
      border-bottom-left-radius: utils.in_rem(8px);
      border-bottom-right-radius: utils.in_rem(8px);
      padding: utils.in_rem(8px);

      .contacts-list {
        display: flex;
        flex-direction: column;
        gap: utils.in_rem(12px);
      }
    }
  }
</style>

<script>
  import Icon from "../../../../../../svelte-design-system/components/atoms/Icon.svelte";
  import { attendeesState } from "../attendeesState.svelte";
  import ConferenceAttendee from "./ConferenceAttendee.svelte";

  const attendeesList = $derived(attendeesState.attendees);
  let isExpanded = $state(true);

  const toggleExpanded = () => {
    isExpanded = !isExpanded;
  };
</script>

<div class="conference-call">
  <div class="top-row" class:expanded={isExpanded}>
    <div class="conference-header" class:expanded={isExpanded}>
      <div class="profile-container">
        <div class="contact">
          <div class="conference-avatar">
            <i class="fa-solid fa-users" size="small"></i>
          </div>
          <div class="profile-info">
            <div class="title">Conference Call</div>
            <div class="subtitle">with {attendeesList.length} people</div>
          </div>
        </div>
        <button
          class="chevron"
          onclick={toggleExpanded}
          aria-label="Toggle conference call details"
        >
          <Icon
            class={`fa-regular fa-chevron-${isExpanded ? "up" : "down"}`}
            size="xs"
          />
        </button>
      </div>
    </div>
  </div>

  {#if isExpanded}
    <div class="contacts-panel">
      <div class="contacts-list">
        {#each attendeesList as attendee}
          <ConferenceAttendee {attendee} />
        {/each}
      </div>
    </div>
  {/if}
</div>
